import { render, staticRenderFns } from "./ProductMold.vue?vue&type=template&id=e90b7b34&"
import script from "./ProductMold.vue?vue&type=script&lang=js&"
export * from "./ProductMold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports